export async function getOmnibusPriceFromAPI(brand, ID) {
    let jsonData;
  
    try {
      const response = await fetch(`https://omnibus.filoblu.com/?brand=${brand}&sku=${ID}&market=${window.location.host}${window.Shopify.routes.root}`);
      jsonData = await response.json();
    } catch (e) {
      return 0;
    }
  
    return jsonData.price;
  };
  
  export async function renderOmnibusPriceFromAPI(brand, price, variantPrice, hasPromo) {
    const omnibuspriceContainer = document.querySelectorAll(`[data-omnibus_brand="${brand}"`)[0];
  
    if(!!variantPrice && (parseFloat(price)*100 == variantPrice)) {
      hideOmnibuspriceContainer(omnibuspriceContainer);
      return;
    }
  
    if (!price) {
      hideOmnibuspriceContainer(omnibuspriceContainer);
      return;
    }

	if (hasPromo == 0) {
		hideOmnibuspriceContainer(omnibuspriceContainer);
		return;
	}
  
    omnibuspriceContainer.classList.remove('hidden');
    const omnibuspriceValue = omnibuspriceContainer.querySelector('.omnibusprice-value');
    omnibuspriceValue.innerText = formatMoney(price.toFixed(2), window.theme.moneyFormat);
  };
  
  const hideOmnibuspriceContainer = (omnibuspriceContainer) => {
    if (!omnibuspriceContainer.classList.contains('hidden')) {
      omnibuspriceContainer.classList.add('hidden');
    }
}

var moneyFormat = "${{amount}}"; // eslint-disable-line camelcase

function formatMoney(cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || moneyFormat;

  function formatWithDelimiters(number, precision, thousands, decimal) {
    thousands = thousands || ",";
    decimal = decimal || ".";

    if (isNaN(number) || number === null) {
      return 0;
    }
    
    if (number % 100 == 0) {
      number = (number / 100.0).toFixed(0);
    } else {
      number = (number / 100.0).toFixed(precision);

    }

    var parts = number.split(".");
    var dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      "$1" + thousands
    );
    var centsAmount = parts[1] ? decimal + parts[1] : "";

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}